module.exports = {"complaintSearcherTitle":"Wyszukaj zgłoszenie","complaintNumber":"Numer zgłoszenia","complaintPassword":"Hasło","searchComplaintBtn":"Szukaj"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchComplaint/translate.json
// module id = 1285
// module chunks = 0